import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/Button';

export function validatePassword(password, confirmation) {
  if (Array.from(password).length < 12)
    return 'Password must have at least 12 characters.';
  if (new Blob([password]).size > 72)
    return 'Password must be no more than 72 bytes.';
  if (password !== confirmation) return 'Passwords do not match.';
  return '';
}

export default function PasswordFields({
  password,
  confirmation,
  onChange,
  disabled,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <div>
        <label
          htmlFor="partner-password"
          className="block text-sm font-medium mb-1"
        >
          New password
        </label>
        <div className="flex gap-2">
          <Input
            id="partner-password"
            type={visible ? 'text' : 'password'}
            value={password}
            autoComplete="new-password"
            required
            minLength={12}
            disabled={disabled}
            aria-describedby="partner-password-help"
            onChange={(event) => onChange('password', event.target.value)}
          />
          <Button
            type="button"
            variant="outline"
            size="icon"
            disabled={disabled}
            aria-label={visible ? 'Hide password' : 'Show password'}
            aria-pressed={visible}
            onClick={() => setVisible(!visible)}
          >
            {visible ? <EyeOff /> : <Eye />}
          </Button>
        </div>
        <p id="partner-password-help" className="text-xs text-gray-500 mt-1">
          At least 12 characters, up to 72 bytes.
        </p>
      </div>
      <div>
        <label
          htmlFor="partner-password-confirm"
          className="block text-sm font-medium mb-1"
        >
          Confirm password
        </label>
        <Input
          id="partner-password-confirm"
          type="password"
          value={confirmation}
          autoComplete="new-password"
          required
          disabled={disabled}
          onChange={(event) => onChange('confirmation', event.target.value)}
        />
      </div>
    </>
  );
}
